import { IsNotEmpty } from 'class-validator';

import { PepBatchSignEventDto } from './pep-batch-sign-event.dto';

export class SignPepBatchDto {
  @IsNotEmpty()
  events: PepBatchSignEventDto[];
}
